import { Injectable } from '@angular/core';
import { LanguageService } from 'src/app/core/language/services/language.service';
import { EvsbThankYouOutboundMapper } from './evsb-thank-you-outbound.mapper';
import { EvsbThankYouOutboundModel } from './evsb-thank-you-outbound.model';

@Injectable()
export class EvsbThankYouOutboundService {
  constructor(private mapper: EvsbThankYouOutboundMapper, private language: LanguageService) {}

  public getModel(): EvsbThankYouOutboundModel {
    return this.mapper.map(this.language.language);
  }
}
